import React, { useMemo } from "react";
import { Button, Card, CardBody, Col, Input, Label, Row, TabPane } from "reactstrap";
import ReactSelect from "react-select";
import ReactTable from "@dhn/components/molecules/data-table";
import ReactFormat from "react-number-format";
import ModalTabServicesAddResult from "../../../../modals/ModalAppointmentEarrings/ModalTabServicesAddResult";
import ModalConfirmRemoveService from "./modals.js/ModalConfirmRemoveService";
import StatusBadge from "@dhn/components/molecules/status-badge";
export default function Services({
  onChangeTabServices,
  onChange,
  tabServices,
  appointmentId,
  addToast,
  patientId,
  handleLoadAppointmetRefetch,
  isOpenModalRemoveServices,
  validateAvailableQuantity,
  isPageModalHistory,
}) {
  const { appointmentHistoryServices } = tabServices;

  const {
    consultoryDifferentTotal,
    insuredCoverageTotal,
    quantityTotal,
    consultoryFeeTotal,
    totalTotal,
  } = appointmentHistoryServices?.reduce(
    (acc, item) => {
      const {
        consultoryDifferent = 0,
        insuredCoverage = 0,
        quantity = 0,
        insuredContrated = 0,
        consultoryFee = 0,
      } = item;

      const subtotal = consultoryDifferent * quantity;

      acc.consultoryDifferentTotal += consultoryDifferent;
      acc.insuredCoverageTotal += insuredCoverage;
      acc.quantityTotal += quantity;
      acc.totalTotal += subtotal;
      acc.insuredContratedTotal += insuredContrated;
      acc.consultoryFeeTotal += consultoryFee;
      return acc;
    },
    {
      consultoryDifferentTotal: 0,
      insuredCoverageTotal: 0,
      quantityTotal: 0,
      totalTotal: 0,
      consultoryFeeTotal: 0,
    }
  );

  const row = useMemo(() => {
    return {
      Header: "Cantidad",
      className: "p-1",
      Cell: ({ original }) => {
        return (
          <ReactFormat
            className="text-right"
            style={{ height: 27 }}
            thousandSeparator={true}
            placeholder="0"
            value={original?.quantity || ""}
            customInput={Input}
            allowNegative={false}
            disabled={isPageModalHistory}
            onBlur={({ target: { value } }) => {
              if (!!original?.quotationId)
                validateAvailableQuantity(
                  {
                    where: {
                      productId: original?.services?.id,
                      quotationId: original?.quotationId,
                    },
                  },
                  value
                );
            }}
            onValueChange={({ floatValue }) => {
              onChangeTabServices("quantity", floatValue, original.services.id);
            }}
          />
        );
      },
    };
  }, [isPageModalHistory, onChangeTabServices, validateAvailableQuantity]);

  return (
    <TabPane tabId={3} className="">
      <ModalConfirmRemoveService
        isOpen={isOpenModalRemoveServices}
        handleLoadAppointmetRefetch={handleLoadAppointmetRefetch}
        onChange={onChange}
      />
      <div className="animated fadeIn">
        <ModalTabServicesAddResult
          isOpen={tabServices?.isOpenModal}
          dataNecesaryModal={tabServices?.dataNecesaryModal}
          {...{ onChange, onChangeTabServices, isPageModalHistory }}
        />
        <Card>
          <CardBody>
            <Row form hidden={isPageModalHistory} >
              <Col md={3}>
                <Label>Servicios de Salud:</Label>
                <ReactSelect
                  getOptionLabel={(item) => item?.services?.name}
                  getOptionValue={(item) => item}
                  placeholder="Seleccionar Servicio"
                  options={tabServices?.optionsDataServices || []}
                  value={""}
                  onChange={(item) => {
                    if (!item?.consultoryDifferent)
                      return addToast(
                        "Este Servicio de Salud no contiene Los precios Requeridos. Por favor Verifique!!! ",
                        { appearance: "error", autoDismiss: true }
                      );
                    onChange(
                      "tabServices",
                      [
                        ...tabServices?.appointmentHistoryServices,
                        { ...item, quantity: 1, appointmentId, patientId },
                      ],
                      "appointmentHistoryServices"
                    );
                    onChange(
                      "tabServices",
                      tabServices?.optionsDataServices?.filter(
                        (itemFilter) =>
                          itemFilter.services?.id !== item.services?.id
                      ),
                      "optionsDataServices"
                    );
                  }}
                />
              </Col>
            </Row>
            <Row form className="mt-4">
              <Col>
                <ReactTable
                  data={tabServices?.appointmentHistoryServices || []}
                  defaultPageSize={5}
                  noDataText="No hay Servicios de Salud"
                  className="-striped -highlight"
                  columns={[
                    {
                      Header: "Servicios",
                      minWidth: 200,
                      accessor: "services.name",
                      Footer: "Total",
                    },
                    {
                      Header: "Resultado",
                      width: 160,
                      className: "text-center",
                      // Solo los servicios configurados con "Requiere resultado".
                      Cell: ({ original }) => {
                        if (!original?.services?.requiresResult)
                          return (
                            <StatusBadge color="secondary">No requiere</StatusBadge>
                          );

                        return (
                          <Button
                            onClick={() => {
                              onChange("tabServices", true, "isOpenModal");
                              onChange(
                                "tabServices",
                                {
                                  serviceId: original.services.id,
                                  result: original?.result || "",
                                },
                                "dataNecesaryModal"
                              );
                            }}
                            type="button"
                            className="btn-gray-600 card-header-action"
                          >
                            <i className="fa fa-pencil" />
                            {" Digite Resultado"}
                          </Button>
                        );
                      },
                    },
                    {
                      ...row,
                      Footer: (
                        <div className="d-flex justify-content-end">
                          <ReactFormat
                            fixedDecimalScale={true}
                            thousandSeparator={true}
                            value={quantityTotal || ""}
                            displayType="text"
                          />
                        </div>
                      ),
                    },
                    {
                      Header: "Monto",
                      columns: [
                        {
                          Header: "Tarifa",
                          className: "text-right",
                          Cell: ({ original }) => (
                            <ReactFormat
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                              value={original?.consultoryFee || ""}
                              displayType="text"
                              decimalScale={2}
                              prefix="$"
                            />
                          ),
                          Footer: (
                            <ReactFormat
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                              value={consultoryFeeTotal || 0}
                              displayType="text"
                              decimalScale={2}
                              prefix="$"
                            />
                          ),
                        },
                        {
                          Header: "Cobertura",
                          className: "text-right",
                          Cell: ({ original }) => (
                            <ReactFormat
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                              value={original?.insuredCoverage || 0}
                              displayType="text"
                              decimalScale={2}
                              prefix="$"
                            />
                          ),
                          Footer: (
                            <ReactFormat
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                              value={insuredCoverageTotal || 0}
                              displayType="text"
                              decimalScale={2}
                              prefix="$"
                            />
                          ),
                        },
                        {
                          Header: "Diferencia",
                          className: "text-right",
                          Cell: ({ original }) => (
                            <ReactFormat
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                              value={original?.consultoryDifferent || 0}
                              decimalScale={2}
                              displayType="text"
                              prefix="$"
                            />
                          ),
                          Footer: (
                            <div>
                              <ReactFormat
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                value={consultoryDifferentTotal || 0}
                                displayType="text"
                                decimalScale={2}
                                prefix="$"
                              />
                            </div>
                          ),
                        },
                        {
                          Header: "Total",
                          className: "text-right",
                          Cell: ({ original }) => {
                            return (
                              <ReactFormat
                                className="text-right"
                                style={{ height: 27 }}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                value={
                                  original?.consultoryDifferent *
                                    original.quantity || 0
                                }
                                displayType="text"
                                allowNegative={false}
                                decimalScale={2}
                                prefix="$"
                              />
                            );
                          },
                          Footer: (
                            <ReactFormat
                              className="text-right"
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                              value={totalTotal || 0}
                              displayType="text"
                              allowNegative={false}
                              decimalScale={2}
                              prefix="$"
                            />
                          ),
                        },
                      ],
                    },
                    {
                      Header: "Opciones",
                      width: 100,
                      show: !isPageModalHistory,
                      Cell: ({ original }) => {
                        return (
                          <Button
                            color="danger"
                            type="button"
                            onClick={() => {
                              onChangeTabServices(
                                "removeHisService",
                                original,
                                original.services.id
                              );
                            }}
                            className="btn-color-danger card-header-action"
                          >
                            <i className={"fa fa-trash"} />
                            {"  Borrar"}
                          </Button>
                        );
                      },
                    },
                  ]}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </TabPane>
  );
}
